/// <amd-module name="Artifacts/FeedSettings/redux/Contracts" />

import { IFeedSettings } from "Artifacts/FeedSettings/types";
import { ComponentState } from "Artifacts/Root/Constants";
import { Feed, FeedPermission, FeedView } from "Artifacts/Root/web-apis/contracts/Feed";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

export type ViewPermissionMap = Record<string, FeedPermission[]>;

export interface IFeedSettingsHubState {
  // Feed details tab
  componentState: ComponentState;
  settings?: IFeedSettings;
  saveGeneralSettingsComponentState: ComponentState;
  deleteFeedComponentState: ComponentState;

  // Feed recycle bin/deleted feed experience
  permanentDeleteFeedComponentState: ComponentState;

  // Permissions tab
  permissionsComponentState: ComponentState;
  permissions?: FeedPermission[];

  // Views tab
  viewsPermissionsComponentState: ComponentState;
  deleteFeedViewComponentState: ComponentState;
  viewPermissionMap?: ViewPermissionMap;

  // Add upstreams panel
  feeds?: Feed[];
  sameCollectionFeedListComponentState: ComponentState;
  feedViews?: FeedView[];
  serviceEndpoints?: ServiceEndpoint[];
  serviceConnectionsComponentState: ComponentState;

  /**
   * Controls loading for when the 'save' button is clicked
   * in the upstreams tab
   */
  saveUpstreamsComponentState: ComponentState;
  /**
   * Controls loading for when the user submits a new upstream
   * in the add upstream panel
   */
  addUpstreamComponentState: ComponentState;
  /**
   * Controls loading for when the user submits a new permission
   * in the add permission panel
   */
  addPermissionComponentState: ComponentState;

  /**
   * Controls loading for when the user deletes a permission
   */
  deletePermissionComponentState: ComponentState;

  /**
   * Controls loading for when the user submits view changes
   * in the add/update view panel
   */
  updateViewPermissionsComponentState: ComponentState;

  isUpstreamsDirty: boolean;
}
